import moment from 'moment';

export default {
  message: ':attribute is not a valid date',
  fn: (value) => moment(value).isValid()
};
